
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../vue-loader/lib/style-rewriter?id=data-v-2ef54d25!../../../vue-loader/lib/selector?type=styles&index=0!./CalendarNav.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./CalendarNav.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-2ef54d25!../../../vue-loader/lib/selector?type=template&index=0!./CalendarNav.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/v-calendar/src/components/CalendarNav.vue
// module id = 672
// module chunks = 94